// src/components/professor/InstallSection.js
import React, { useState } from "react";
import Preloader from "../../components/Preloader";
import { getStorage, ref, getDownloadURL } from "firebase/storage"; // New import
import { Apple, MonitorDown } from "lucide-react";

const InstallSection = ({ theme }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async (platform) => {
    setLoading(true);
    let filePath = "";

    if (platform === "Windows") {
      // Firebase Storage path for Windows executable
      filePath = "install/CoursEngage Setup 1.0.0.exe";
    } else if (platform === "Mac") {
      // Firebase Storage path for Mac DMG
      filePath = "install/CoursEngage-1.0.0-arm64.dmg";
    }

    try {
      const storage = getStorage();
      const fileRef = ref(storage, filePath);
      const downloadLink = await getDownloadURL(fileRef);
      // Trigger the download using the retrieved URL
      window.location.href = downloadLink;
      // Simulate async operation (e.g., to show the Preloader for a moment)
      await new Promise((resolve) => setTimeout(resolve, 2000));
      alert(`Download for ${platform} started!`);
    } catch (error) {
      console.error(`Error downloading for ${platform}:`, error);
      alert(`Failed to download for ${platform}.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="install-section"
      className="p-0"
      style={{
        backgroundColor: "var(--section-bg)",
        color: "var(--text-color)",
      }}
    >
      {loading && <Preloader />}

      <div className="grid gap-4 sm:grid-cols-2">
        {/* Windows Button */}
        <div className="rounded-lg border p-4" style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--border-color)', boxShadow: 'var(--shadow-sm)' }}>
          <button
            onClick={() => handleDownload("Windows")}
            className="flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-semibold text-white transition-colors duration-200"
            style={{ backgroundColor: "var(--primary-color)" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--hover-color)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--primary-color)")
            }
          >
            <MonitorDown size={17} aria-hidden="true" />
            <span>Download for Windows</span>
          </button>
        </div>

        {/* Mac Button */}
        <div className="rounded-lg border p-4" style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--border-color)', boxShadow: 'var(--shadow-sm)' }}>
          <button
            onClick={() => handleDownload("Mac")}
            className="flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-semibold text-white transition-colors duration-200"
            style={{ backgroundColor: "var(--primary-color)" }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--hover-color)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--primary-color)")
            }
          >
            <Apple size={17} aria-hidden="true" />
            <span>Download for Mac</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default InstallSection;
